import { module } from 'modujs';
import axios from "axios";

export default class extends module {
    constructor(m) {
        super(m);

        this.target = document.querySelector( this.el.dataset.target );
        this.html = document.getElementsByTagName('html')[0];
        this.el.addEventListener( 'click', (e) => {
            e.preventDefault();
            this.el.classList.add( 'loading' );
            this.html.classList.add( 'is-loading' );
            let url = this.el.href + this.el.dataset.params ;
            axios.get( url  ).then( (response) => {
                const doc = document.createElement("div");
                doc.innerHTML = response.data;
                this.target.innerHTML = doc.querySelector(this.el.dataset.target ).innerHTML;
                this.el.classList.remove( 'loading' );
                this.call('update', false, 'Scroll');
                this.call('updateLazy', false, 'Scroll');
                this.html.classList.remove( 'is-loading' );
            });
        });

    }
    init() {}
    destroy(){}
}
